import type { AlignmentStatus, Sensor } from '../api/models';

export const statusSphereColor = (sensor: Sensor): string => {
  if (!sensor.pcdUrl) {
    return '#94a3b8';
  }
  return sensor.alignmentStatus === 'aligned' ? '#10b981' : '#f59e0b';
};

export const alignmentStatusColor = (status?: AlignmentStatus | string): string => {
  if (status === 'aligned') return '#10b981';
  if (status === 'unaligned') return '#f59e0b';
  if (status === 'none' || !status) return '#94a3b8';
  return '#cbd5e1';
};

export const shouldShowSensorStatusSphere = (isAlignmentMode: boolean): boolean =>
  isAlignmentMode;
